import React, { useEffect, useState } from 'react';
import { getCampanaToEditAPI } from '../../../../consumers/backendApisUrls';
import { usePropsSelect } from '../../../../hooks/useProps/usePropsSelect';
import BaseCampana from './BaseCampana';
import { usePropsInputs } from '../../../../hooks/useProps/usePropsInput';
import { useManageGetRequest } from '../../../../hooks/useManageGetRequest/useManageGetRequest';

const DetalleCampana = ({ toggleModal, refreshPage, IdCampanaBeneficio }) => {
  const SECTION_NAME = "DetalleCampana";
  const KEYS = {
    Nombre: "Nombre",
    CuotasMax: "CuotasMax",
    FechaInicio: "FechaInicio",
    FechaFin: "FechaFin",
    DiaCorte: "DiaCorte",
    Lineamientos: "LineamientoFile",
    IdPlantilla: "IdPlantilla",
    IdUnidad: "IdUnidad",
    IdCargo: "IdCargo",
    Incluye: "Incluye",
    FechaEnvio: "FechaEnvio",
    VigenciaPedido: "VigenciaPedido",
    ImagenCampania: "ImagenCampaniaFile",
    SignoComparador: "SignoComparador",
    FechaIngreso: "FechaIngreso",
    RequiereDataExterna: "RequiereDataExterna",
    IdTipoEmpleado: "IdTipoEmpleado",
    TextoDescriptivo: "TextoDescriptivo",
    MesesMaximoCuotas: "MesesMaximoCuotas",
    SolicitarNumeroWhatsApp: "SolicitarNumeroWhatsApp",
  };
  const [formValues, setFormValues] = useState({});
  const [allDropdowns, setAllDropdowns] = useState([]);
  const [filas, setFilas] = useState([]);
  const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
  const [selectProps] = usePropsSelect(
    allDropdowns,
    formValues,
    setFormValues,
    SECTION_NAME
  );
  const [isLoading, setIsLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [executeGet] = useManageGetRequest();

  const init = async () => {
    const api = getCampanaToEditAPI(IdCampanaBeneficio);
    await executeGet(api, successInitCallback);
  };

  const successInitCallback = ({ data }) => {
    setFormValues(data);
    const filasPayload = data.Topes.map((row) => {
      return {
        IdUnidad: row.IdsUnidades,
        Incluye: row.Incluye,
        IdCargo: row.IdsCargos,
        Tope: row.Tope,
        SignoComparador: row.SignoComparador,
        FechaIngreso : row.FechaIngreso,
        IdTipoEmpleado: row.IdTipoEmpleado,
      };
    });
    setFilas(filasPayload);
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <BaseCampana
      title="Detalle campaña"
      toggleModal={toggleModal}
      puedeEditar={false}
      sectionName={SECTION_NAME}
      filas={filas}
      setFilas={setFilas}
      allDropdowns={allDropdowns}
      setAllDropdowns={setAllDropdowns}
      formValues={formValues}
      setFormValues={setFormValues}
      commonProps={commonProps}
      selectProps={selectProps}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      isUploading={isUploading}
      setIsUploading={setIsUploading}
      KEYS={KEYS}
    />
  );
};

export default DetalleCampana;